import request from '../../utils/request';

// 获取入驻资质列表
export function getQualificationInfo() {
  return request({
    url: '/shop/distribution/getQualificationInfo',
    method: 'get'
  })
}

// 获取登录后的入驻状态信息
export function getLoginDistributionInfo(query) {
  return request({
    url: '/shop/distribution/distributionInfo',
    method: 'get',
    params: query
  })
}

// 获取资质信息
export function getAccountInfo(query) {
  return request({
    url: '/shop/distribution/getYeePayAccountInfo',
    method: 'get',
    params: query
  })
}

// 上传基本信息
export function addDistributionInfo(data) {
  return request({
    url: '/shop/distribution/addDistributionInfo',
    method: 'post',
    data: data
  })
}

// 提交资质
export function addDistributionAuth(data) {
  return request({
    url: '/shop/distribution/addDistributionAuth',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/distribution/index.js